import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { UtilityService } from 'src/app/service/utility.service';
import {FollowupMeetingPopupComponent} from 'src/app/components/followup-meeting-popup/followup-meeting-popup.component';
import { PermissionService } from 'src/app/service/permission.service';
import { NgxSpinnerService } from 'ngx-spinner';
export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'MMM DD, yyyy',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-copymeeting',
  templateUrl: './copymeeting.component.html',
  styleUrls: ['./copymeeting.component.css'],
  providers: [{ provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    , DatePipe]
})
export class CopymeetingComponent implements OnInit {

  followUpData : any;

  meetingId:any;
  meetingDate:any;
  currentTime:any;
  oldMeetingDate: any;
  oldMeetingTime: any;
  meetingTitle : any;
  includeAttendee = true;
  includeAgenda = true;
  newMeetingTitle:any;
  location:any;

  attendees:any;
  agendas:any;

  popupIdentifier = 'Follow-up Meeting';
  isConfidential: any;

  constructor(private util:UtilityService,private permissionService:PermissionService,private matDailogRef: MatDialogRef<CopymeetingComponent>,private meeting:MeetingService,private datepipe:DatePipe,private utility:UtilityService,private globals: Globals,private _mdr: MatDialogRef<CopymeetingComponent>,@Inject(MAT_DIALOG_DATA) data: any,private spinner: NgxSpinnerService) {
    this.isConfidential = data.meeting.isConfidential;
    this.meetingId = data.meeting.meetingId;
    this.oldMeetingTime = data.meeting.meetingStartTime;
    this.oldMeetingDate =  this.datepipe.transform(data.meeting.meetingDateStr, "MMM dd, YYYY");
    this.meetingDate =  new Date(this.utility.getDefaultMeetingDate());
    this.meetingTitle = data.meeting.meetingTitle,
    this.newMeetingTitle = data.meeting.meetingTitle
    this.followUpData = data
    
    this.currentTime = this.utility.getDefaultMeetingTime();
   }
    
  ngOnInit(): void {
 
  }

  saveCopyMeeting(){

    this.spinner.show();
        var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS,this.util.permissionType.READ);
    if(!accessFlag){
      this.spinner.hide();
      return;
    }
    let new_meetingDate = this.datepipe.transform(this.meetingDate, "MMM dd, YYYY");
   
    if(this.includeAttendee==true && this.includeAgenda==true){
     
      this.attendees = "Y";
      this.agendas = "Y";
      
    }else if(this.includeAgenda==false && this.includeAttendee==true){
      
      this.attendees = "Y";
      this.agendas = "N";
     }else if(this.includeAgenda==true && this.includeAttendee==false){

      this.attendees = "N";
      this.agendas = "Y";
     } else{
      this.attendees = "N";
      this.agendas = "N";
    }
    

    var copyMeetingJson = {
      
        "meetingId":this.meetingId,
        "meetingDateStr":this.oldMeetingDate,
        "meetingStartTime":this.oldMeetingTime,
        "includeAttendee": this.attendees,
        "includeAgenda": this.agendas,
        "newMeetingDate":new_meetingDate,
        "userId":localStorage.getItem('userId'),
        "newMeetingTime":this.currentTime,
        "isTemplate":"Y",
        "rescheduleFlag":"",
        "newMeetingTitle":this.newMeetingTitle,
        "location":this.location,
        "visitorTimeZone":this.globals.vTimeZone,
        "encryptTitleKey" : this.newMeetingTitle,
        "decryptKey" : "",
        "isConfidential" : "",
    }
    if(this.isConfidential == "Y"){
      copyMeetingJson.isConfidential = "Y";
      copyMeetingJson.decryptKey  =  String(localStorage.getItem("savedpasswords"+"_"+this.meetingId));
      
    }
    this.meeting.copyMeeting(copyMeetingJson).subscribe((resp:any)=>{
      this.matDailogRef.close(true);
      this.spinner.hide();
    });

    


  }


  closeDialog() {
    this._mdr.close(false)
  }

}
